/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { TextStyleFromJSON, TextStyleToJSON, ViewStyleFromJSON, ViewStyleToJSON, } from './';
export function PickListThemeFromJSON(json) {
    return PickListThemeFromJSONTyped(json, false);
}
export function PickListThemeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'optionViewStyle': !exists(json, 'option_view_style') ? undefined : ViewStyleFromJSON(json['option_view_style']),
        'optionTextStyle': !exists(json, 'option_text_style') ? undefined : TextStyleFromJSON(json['option_text_style']),
    };
}
export function PickListThemeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'option_view_style': ViewStyleToJSON(value.optionViewStyle),
        'option_text_style': TextStyleToJSON(value.optionTextStyle),
    };
}
//# sourceMappingURL=PickListTheme.js.map